export class ActivitySetPlannedVisitDateModel {
    commentKind: number;
    comment: string;
    planStartDate: Date;
    transferInitiatorId?: number;
}